'use es6';

import { useWindowDimensionsContext } from 'marketplace-ui-common/hooks/useWindowDimensionsContext';
const POINTS = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200
};

const useWindowWidth = breakpoints => {
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  return breakpoints ? Object.keys(breakpoints).reduce((result, size) => {
    return windowWidth >= POINTS[size] ? result || breakpoints[size] : result;
  }, false) : windowWidth;
};

export default useWindowWidth;